import { z, ZodSchema } from "zod";
import { useMutation } from "@tanstack/react-query";
import { formatFirebaseError } from "@shared/services/api/formatFirebaseError";
import { sendPasswordReset } from "../utils/sendPasswordReset";

type Args = {
  onSuccess?: (data: any) => void;
  schema: ZodSchema;
  onError?: () => void;
};

export function useForgotPasswordMutation({
  onSuccess,
  schema,
  onError,
}: Args) {
  return useMutation({
    mutationFn: async (data: z.infer<typeof schema>) => {
      return await sendPasswordReset({ email: data.email, onError });
    },
    onError: (error: Error) => {
      throw new Error(formatFirebaseError(error.message));
    },
    onSuccess: (data) => {
      // submit callback
      onSuccess?.(data);
    },
  });
}

export default useForgotPasswordMutation;
